import { MonthAndYearState } from "components/month-year-select/MonthYearSelect";
import { Select } from "components/ui/select/Select";
import { makeMonthOptions } from "utilities/date";

interface IMonthSelectProps {
  readonly label?: string;
  readonly className?: string;
  readonly monthAndYear?: MonthAndYearState;
  readonly errorMessage?: string;
  readonly onChange: (...event: any[]) => void;
}

export function MonthSelect({
  label,
  className = "",
  monthAndYear,
  errorMessage,
  onChange,
}: IMonthSelectProps) {
  const handleOnChange = (e: any) => {
    onChange((previousValue: MonthAndYearState) => ({
      ...previousValue,
      month: e as string,
    }));
  };
  return (
    <Select
      options={makeMonthOptions(Number(monthAndYear?.year))}
      placeholder="Month"
      label={label}
      className={className}
      onChange={handleOnChange}
      errorMessage={errorMessage}
    />
  );
}
